export { default } from './EndorseContentLayout';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/EndorseContentLayout/index.js